import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, GState, LocaleX, LogicX, NavX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XImage, XText } from "IZOX/_X";
import Funcs from "__SYSDefault/Funcs";

/**
 * @augments {Component<Props, State>}
 */
class LoginBtn extends Component {

  static propTypes = {
    history: PropsType.object
  }

  static defaultProps = {
    history: {}
  }

  constructor(){
    super();
    this.state = {
      showMenu: false
    };
  }

  componentDidMount(){
    this._setAllStates();
    window.addEventListener("mousedown", this._onClickOutSide);
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(LoginBtn.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this._onClickOutSide);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _onLoginPress = (e) => { 
    let {_closeReg, history} = this.props;
    _closeReg?.();
    if(GState.loggedIn){
      this._toggleMenu(e);
    }else{
      NavX.Goto(history, "/Login");
    }
  }

  _toggleMenu = (e) => {
    let rect = this.ref.getBoundingClientRect();
    GFunc.SelectorOverlay(() => {
      return (
        <VStack position="absolute"
          style={{
            top: rect.y - 40,
            left: rect.x - 27,
            width: 200,
            height: 300
          }}>
          {this.renderSubMenu()}
        </VStack>
      );
    }, {}, true, false, true);
  }
  
  /**
     * 
     * @param {React.MouseEvent<HTMLDivElement, MouseEvent>} e 
     */
  _onClickOutSide = (e) => {
    if (this.ref && e.target.contains(this.ref)) {
      this._closeMenu();
    }
  }

  _closeMenu = () => {
    GFunc.CloseSelectorOverlay();
  }

  _toUserDashboard = () => {
    let {history} = this.props;
    this._closeMenu();

    let roles = GFunc.GetUserRoles();

    let page = "";
    if(LogicX.includesOneOf(roles, ["Agent"])){
      page = "/Agent/Dashboard";
    }else if(LogicX.includesOneOf(roles, ["DCustomer", "Client"])){
      page = "/DCustomer/Dashboard";
    }else if(LogicX.includesOneOf(roles, ["Insurer"])){
      page = "/Insurer/AllPolicies";
    }

    NavX.Goto(history, page);
    Funcs.SetMenuClick(page);
  }

  _toChangePassword = () => {
    let {history} = this.props;
    this._closeMenu();
    let page = "/User/ChangePassword";
    NavX.Goto(history, page);
    Funcs.SetMenuClick(page);
  }

  _toRedirect = () => {
    let {history} = this.props;
    let page = "/User/Redirect";
    GFunc.CloseSelectorOverlay();
    NavX.Goto(history, page);
    Funcs.SetMenuClick(page);
  }

  _toLogout = () => {
    let {history} = this.props;
    GFunc.Logout();
    this._closeMenu();
    let page = "/Logout";
    NavX.Goto(history, page);
    Funcs.SetMenuClick(page);
  }

  renderSubMenuBtn(caption, func){
    return (
      <XButton onPress={func} color={ColorX.CSS("Axit")} pV={8} pH={12}
        round={0} width={150} style={{
          borderBottomWidth: 1,
          borderStyle: "solid",
          borderColor: ColorX.CSS("greyOut", 0.2)
        }}>
        <HStack HAlign="[">
          <XText fontSize={14} textAlign="[" fullWidth>
            {LocaleX.Parse(caption)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderSubMenu = () => {
    if(GFunc.GetUserStatus() !== "Active") {
      return this.renderSubMenuBeforeApproval();
    }
    return this.renderSubMenuAfterApproval();
  }

  renderSubMenuAfterApproval = () => {
    return (
      <VStack style={{position: "absolute", top: 80, zIndex: 300}} 
        bgColor={ColorX.CSS("pureWhite")}
        shadow>
        {this.renderSubMenuBtn({
          EN: "My Dashboard",
          TC: "我的資訊"
        }, this._toUserDashboard)}
        {this.renderSubMenuBtn({
          EN: "Change Password",
          TC: "變更密碼"
        }, this._toChangePassword)}
        {this.renderSubMenuBtn({
          EN: "Log out",
          TC: "登出"
        }, this._toLogout)}
      </VStack>
    );
  }

  renderSubMenuBeforeApproval = () => {
    return (
      <VStack style={{position: "absolute", top: 80, zIndex: 300}} 
        bgColor={ColorX.CSS("pureWhite")}
        shadow>
        {this.renderSubMenuBtn({
          EN: "Fill Profile",
          TC: "填寫我的資訊"
        }, this._toRedirect)}
        {this.renderSubMenuBtn({
          EN: "Change Password",
          TC: "變更密碼"
        }, this._toChangePassword)}
        {this.renderSubMenuBtn({
          EN: "Log out",
          TC: "登出"
        }, this._toLogout)}
      </VStack>
    );
  }

  renderBtn(){
    return (
      <HStack forwardRef={e => this.ref = e} 
        fullWidth HAlign="]" flexShrink={0}>
        <XButton fullWidth flexShrink={0} color={ColorX.CSS("DeepBlueSea")} 
          onPress={this._onLoginPress}
          padding={0} pV={8} pH={12} >
          <HStack spacing={8}>
            <XImage source={"/Images/Icons/user.png"} noResize flexShrink={0}/>
            <XText fontSize={14} bold ellipsisMode="ellipsis" flexGrow={1} noWrap>
              {GState.loggedIn ? GFunc.GetUserDisplayName() : 
                LocaleX.Parse({
                  EN: "Login",
                  TC: "登入"
                })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  render(){
    return (
      <VStack VAlign="^" flexShrink={0} maxWidth={150}>
        {this.renderBtn()}
      </VStack>
    );
  }

}

export default observer(LoginBtn);
